import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/amj/result_back.webp";

function Resultamj() {
  return (
    <section
      className="resultamj bg_textcolor"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={8} xxl={8} className="my-auto">
            <div className="result_content">
              <h2>The Result</h2>
              <p>
                With client’s collaboration, teamwork and the motto to innovate,
                Tekrevol developed AMJ Workplace Wellness app, that matches our
                in-house quality standards and exceeds our client’s
                expectations. The app is live and yet to impact the productivity
                and efficiency of countless professionals and their
                organizations.
              </p>
            </div>

            <div className="result_img text-center">
              <StaticImage
                src="../../../images/case-studies/amj/result_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1178}
                height={604}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultamj;
